import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=537eea0e&scoped=true&"
import script from "./user-detail.vue?vue&type=script&lang=js&"
export * from "./user-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=537eea0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537eea0e",
  null
  
)

export default component.exports